const defaultHeaders = new Headers();

const fetchOptions = (method = "GET", body = null) => {
  const options = {
    method,
    headers: defaultHeaders,
    credentials: "include",
    redirect: "follow",
  };
  if (body) {
    options.body = body;
  }
  return options;
};

export const getClienteByRut = async (baseUrl, rut) => {
  const response = await fetch(
    `${baseUrl}getClienteByRut?rut=${rut}`,
    fetchOptions()
  );
  if (!response.ok) throw new Error("Error al verificar RUT");
  return response.json();
};

export const getClienteById = async (baseUrl, idCliente) => {
  const response = await fetch(
    `${baseUrl}getClienteById?idCliente=${idCliente}`,
    fetchOptions()
  );
  if (!response.ok) throw new Error("Error al obtener cliente");
  return response.json();
};

export const getReporteClientes = async (baseUrl) => {
  const response = await fetch(`${baseUrl}reporteClientes`, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) {
    let detalle = `Error al exportar reporte de clientes (${response.status})`;
    try {
      const err = await response.json();
      if (err && err.detalle) {
        detalle = err.detalle;
      }
    } catch (e) {
      // La respuesta de error no es JSON
    }
    throw new Error(detalle);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "reporte_clientes.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const getRepresentanteByRut = async (baseUrl, rut) => {
  const response = await fetch(
    `${baseUrl}getRepresentanteByRut?rut=${rut}`,
    fetchOptions()
  );
  if (!response.ok) throw new Error("Error al buscar representante");
  return response.json();
};

export const getAllEmpresas = async (baseUrl) => {
  const url = `${baseUrl}getAllEmpresas`;
  const response = await fetch(url, fetchOptions());
  if (!response.ok) {
    throw new Error(`Error al obtener las empresas (${response.status})`);
  }
  const data = await response.json();
  if (Array.isArray(data.empresas)) return data.empresas;
  throw new Error("Formato de respuesta inesperado");
};

export const getAllTiposCliente = async (baseUrl) => {
  const url = `${baseUrl}getAllTipoClientes`;
  const response = await fetch(url, fetchOptions());
  if (!response.ok) {
    throw new Error(
      `Error al obtener los tipos de cliente (${response.status})`
    );
  }
  const data = await response.json();
  if (Array.isArray(data.tipos)) return data.tipos;
  throw new Error("Formato de respuesta inesperado");
};

export const crearCliente = async (baseUrl, params) => {
  const url = `${baseUrl}crearCliente?${params.toString()}`;
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
  });
  if (!response.ok) throw new Error("Error al crear el cliente en Bodegas");
  return typeof response.json === "function" ? response.json() : response;
};

export const actualizarCliente = async (baseUrl, params) => {
  const url = `${baseUrl}actualizarCliente?${params.toString()}`;
  const response = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
  if (!response.ok) throw new Error("Error al actualizar en bodegas");
  return response;
};

export const cambiarEstadoCliente = async (baseUrl, idCliente, activo) => {
  const url = `${baseUrl}cambiarEstadoCliente?idCliente=${idCliente}&activo=${activo}`;
  const response = await fetch(url, {
    method: "POST",
    headers: new Headers({
      Authorization: "Basic YWRtaW46a2VzcA==",
      "Content-Type": "application/json;charset=UTF-8",
    }),
  });
  if (!response.ok) throw new Error("Error al cambiar estado del cliente");
  return response;
};

export const cambiarEstadoRepresentante = async (
  baseUrl,
  idRepresentante,
  activo
) => {
  const url = `${baseUrl}cambiarEstadoRepresentante?idRepresentante=${idRepresentante}&activo=${activo}`;
  const response = await fetch(url, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
  if (!response.ok) throw new Error("Error al desactivar representante");
  return response;
};

export const cambiarEstadoDomicilio = async (baseUrl, idDomicilio, activo) => {
  const url = `${baseUrl}cambiarEstadoDomicilio?idDomicilio=${idDomicilio}&activo=${activo}`;
  const response = await fetch(url, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
  if (!response.ok) throw new Error("Error al desactivar domicilio");
  return response;
};

export const cambiarEstadoContacto = async (baseUrl, idContacto, activo) => {
  const url = `${baseUrl}cambiarEstadoContacto?idContacto=${idContacto}&activo=${activo}`;
  const response = await fetch(url, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
  if (!response.ok) throw new Error("Error al desactivar contacto");
  return response;
};

export const crearClienteCobranzas = async (urlCobranzas, data) => {
  const response = await fetch(`${urlCobranzas}clientes/agregar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    credentials: "include",
  });
  if (!response.ok) throw new Error("Error al crear cliente en cobranzas");
  return typeof response.json === "function" ? response.json() : response;
};

export const editarClienteCobranzas = async (urlCobranzas, data) => {
  const response = await fetch(`${urlCobranzas}clientes/editar`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    credentials: "include",
  });
  if (!response.ok) throw new Error("Error al actualizar cliente en cobranzas");
  return response;
};

export const crearClienteDocumentos = async (urlDocumentos, params) => {
  const url = `${urlDocumentos}insertarCliente?${params.toString()}`;
  const response = await fetch(url, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json;charset=UTF-8" }),
    credentials: "include",
  });
  if (!response.ok) throw new Error("Error al crear cliente en documentos");
  return response;
};

export const actualizarClienteDocumentos = async (urlDocumentos, data) => {
  const url = `${urlDocumentos}actualizarCliente`;
  const response = await fetch(url, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json;charset=UTF-8" }),
    credentials: "include",
    body: JSON.stringify(data),
  });
  if (!response.ok)
    throw new Error("Error al actualizar cliente en documentos");
  return response;
};

export const crearClienteMedidores = async (urlMedidores, params) => {
  const url = `${urlMedidores}cliente/insertarCliente?${params.toString()}`;
  const response = await fetch(url, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json;charset=UTF-8" }),
    credentials: "include",
  });
  if (!response.ok) throw new Error("Error al crear cliente en medidores");
  return response;
};

export const actualizarClienteMedidores = async (urlMedidores, data) => {
  const url = `${urlMedidores}cliente/actualizarCliente`;
  const response = await fetch(url, {
    method: "PUT",
    headers: new Headers({ "Content-Type": "application/json;charset=UTF-8" }),
    credentials: "include",
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error("Error al actualizar cliente en medidores");
  return response;
};

export const validarServiciosOperativos = async (
  urlMedidores,
  urlCobranzas,
  urlDocumentos
) => {
  const servicios = [
    {
      nombre: "Medidores",
      url: `${urlMedidores}tipo/buscar`,
      options: { method: "GET", credentials: "include" },
    },
    {
      nombre: "Cobranzas",
      url: `${urlCobranzas}tipoDocumentos`,
      options: { method: "GET", credentials: "include" },
    },
    {
      nombre: "Documentos",
      url: `${urlDocumentos}getTiposDocumento`,
      options: { method: "GET", credentials: "include" },
    },
  ];

  const resultados = await Promise.all(
    servicios.map(async ({ nombre, url, options }) => {
      try {
        const response = await fetch(url, options);
        return { nombre, operativo: response.status < 500 };
      } catch {
        return { nombre, operativo: false };
      }
    })
  );

  return resultados.filter((r) => !r.operativo).map((r) => r.nombre);
};

export const getClientesByFiltro = async (baseUrl, filtro) => {
  const response = await fetch(
    `${baseUrl}getClientesByFiltro?${filtro}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error(`Error al buscar clientes (${response.status})`);
  }
  return response.json();
};

// Agrupación Doc. Ventas: configuración vigente de documentos de venta por cliente/asignación
export const getConfiguracionDocumentos = async (baseUrl, filtros = {}) => {
  const params = new URLSearchParams();
  if (filtros.rut) params.append("rut", filtros.rut);
  if (filtros.razonSocial) params.append("razonSocial", filtros.razonSocial);
  if (filtros.nombre) params.append("nombre", filtros.nombre);
  if (filtros.alias) params.append("alias", filtros.alias);
  const response = await fetch(
    `${baseUrl}getConfiguracionDocumentos?${params.toString()}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error(
      `Error al buscar configuración de documentos (${response.status})`
    );
  }
  return response.json();
};

// Agrupación Doc. Ventas: configuración predeterminada de documentos de
// venta de un cliente para una empresa (combinación cliente + empresa)
export const getConfiguracionPredeterminada = async (baseUrl, idCliente, idEmpresa) => {
  const response = await fetch(
    `${baseUrl}getConfiguracionPredeterminada?idCliente=${idCliente}&idEmpresa=${idEmpresa}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error(
      `Error al buscar la configuración predeterminada (${response.status})`
    );
  }
  return response.json();
};

// Agrupación Doc. Ventas: configura la predeterminada de documentos de venta
// de un cliente. Payload:
// { idCliente, configuracion: [{codigo, cantidadDocumentos}] }
// (cantidad de documentos por tipo, 1..N; sin consolidado: el backend lo
// infiere de la distribución)
export const guardarConfiguracionPredeterminada = async (baseUrl, payload) => {
  const response = await fetch(
    `${baseUrl}guardarConfiguracionPredeterminada`,
    fetchOptions("POST", JSON.stringify(payload))
  );
  if (!response.ok) {
    let mensaje = `Error al guardar la configuración predeterminada (${response.status})`;
    try {
      const data = await response.json();
      if (data && data.mensaje) mensaje = data.mensaje;
    } catch (e) {
      // respuesta sin cuerpo JSON: se mantiene el mensaje por status
    }
    throw new Error(mensaje);
  }
  return response.json();
};

// Agrupación Doc. Ventas: actualiza en lote la asignación de documento de
// ítems existentes de asignaciones vigentes/futuras. Payload:
// { detalles: [{id, agrupamiento}] }
// (agrupamiento = número de documento 1..N dentro del tipo del ítem; el
// estado consolidado lo infiere el backend de la distribución. Ante
// cualquier item inválido el backend revierte el lote completo.)
export const actualizarConfiguracionDetalles = async (baseUrl, payload) => {
  const response = await fetch(
    `${baseUrl}actualizarConfiguracionDetalles`,
    fetchOptions("POST", JSON.stringify(payload))
  );
  if (!response.ok) {
    let mensaje = `Error al actualizar los ítems de las asignaciones (${response.status})`;
    try {
      const data = await response.json();
      if (data && data.mensaje) mensaje = data.mensaje;
      if (data && data.detalle) mensaje = `${mensaje}: ${data.detalle}`;
    } catch (e) {
      // respuesta sin cuerpo JSON: se mantiene el mensaje por status
    }
    throw new Error(mensaje);
  }
  return response.json();
};

// Agrupación Doc. Ventas: catálogo de tipos de documento de venta (tabla tipo_documento)
export const getTiposDocumento = async (baseUrl) => {
  const response = await fetch(`${baseUrl}getTiposDocumento`, fetchOptions());
  if (!response.ok) {
    throw new Error(
      `Error al obtener tipos de documento (${response.status})`
    );
  }
  return response.json();
};

export const getClientesByRepresentante = async (baseUrl, nombre) => {
  const response = await fetch(
    `${baseUrl}getClientesByRepresentante?nombre=${nombre}`,
    fetchOptions()
  );
  if (!response.ok) {
    throw new Error(
      `Error al buscar clientes por representante (${response.status})`
    );
  }
  return response.json();
};
